import { useEffect } from 'react';

/* Aligns the built-in chat bubble's right edge with the header's horizontal padding
   (px-4 / md:px-10 / lg:px-[56px] => 16 / 40 / 56px). */
const BUTTON_ID = 'vapi-widget-floating-button';

function headerInset() {
  const w = window.innerWidth;
  if (w >= 1024) return 56;
  if (w >= 768) return 40;
  return 16;
}

function fixedHost(btn: HTMLElement): HTMLElement {
  let el: HTMLElement | null = btn;
  while (el && el !== document.body) {
    if (getComputedStyle(el).position === 'fixed') return el;
    el = el.parentElement;
  }
  return btn;
}

export default function ChatWidgetPosition() {
  useEffect(() => {
    const apply = () => {
      const btn = document.getElementById(BUTTON_ID);
      if (!btn) return false;
      const host = fixedHost(btn);
      const inset = `${headerInset()}px`;
      host.style.setProperty('right', inset, 'important');
      // Desktop: hero cards sit 56px above the viewport bottom (16px section gap + 40px padding).
      host.style.setProperty('bottom', inset, 'important');
      return true;
    };
    const mo = new MutationObserver(() => { if (apply()) mo.disconnect(); });
    if (!apply()) mo.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', apply);
    return () => { mo.disconnect(); window.removeEventListener('resize', apply); };
  }, []);
  return null;
}